import React from 'react';

interface Icon3DEmailProps {
  size?: string;
}

const Icon3DEmail: React.FC<Icon3DEmailProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'flip-email 3s ease-in-out infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <svg 
          viewBox="0 0 24 24" 
          fill="none" 
          className="w-full h-full"
          style={{ filter: 'drop-shadow(0 2px 8px rgba(236, 72, 153, 0.3))' }}
        >
          <defs>
            <linearGradient id="emailGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#ec4899" />
              <stop offset="50%" stopColor="#f472b6" />
              <stop offset="100%" stopColor="#db2777" />
            </linearGradient>
          </defs>
          <rect x="2" y="4" width="20" height="16" rx="2" fill="url(#emailGradient)" opacity="0.2" stroke="url(#emailGradient)" strokeWidth="1.5" />
          <path d="M2 6l10 7.5L22 6" stroke="url(#emailGradient)" strokeWidth="1.5" fill="none" />
          <line x1="2" y1="6" x2="22" y2="6" stroke="url(#emailGradient)" strokeWidth="1" />
        </svg>
        <style>{`
          @keyframes flip-email {
            0%, 100% { transform: rotateY(0deg) rotateX(0deg); }
            50% { transform: rotateY(180deg) rotateX(10deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DEmail;
